<template>
    <div id="badge_details" class="seller-badge-modal">
        <Modal
            :title="badge.badge_name??''"
            :header="true"
            :footer="false"
            :width="'45%'"
            v-if="showBadgeDetailsModal"
            @close="hideModal">
            <template slot="header" v-if="badge.id">
                <div class="modal-img">
                    <img :src="badge.badge_logo" :alt="badge.badge_name">
                </div>
                <div class="modal-title">
                    <h2>{{ badge.badge_name }}</h2>
                    <p v-if="(is_frontend || vendor_id) && 'years_active' !== badge.event_type">{{ sprintf( __('Level: %d of %d', 'dokan'), badge.acquired_level_count, badge.level_count ) }}</p>
                    <p v-else-if="(is_frontend || vendor_id) && 'years_active' === badge.event_type">{{ sprintf( __('Level: %d', 'dokan'), badge.acquired_level_count ) }}</p>
                    <p v-else-if="( ! vendor_id && ! is_frontend )">{{ __( 'No. of Vendors: ', 'dokan' ) }} <span class="color-blue">{{ badge.vendor_count }}</span></p>
                </div>
            </template>
            <template slot="body">
                <div class="badge-details" v-if="badge.id">
                    <div v-if="badge.levels.length > 0">
                        <div class="modal-sub-title">
                            <h3>{{ __( 'Achieved Levels:', 'dokan' ) }}</h3>
                        </div>
                        <div class="modal-level-box" v-for="(level, index) in badge.levels" :title="sprintf( __( 'Level %d', 'dokan' ), index + 1 )" :key="index">
                            <div class="level_description">
                                <div class="left-content">
                                    <div class="modal-img container">
                                        <img :src="badge.badge_logo" :alt="badge.badge_name">
                                        <strong v-if="'years_active' !== badge.event_type" class="bottom-center">{{ index + 1 }} </strong>
                                        <strong v-if="'years_active' === badge.event_type" class="bottom-center">{{ badge.acquired_level_count }} </strong>
                                    </div>
                                </div>
                                <div class="right-content">
                                    <p v-html="getBadgeLevelConditionText(badge.event, level, getVerificationTypes)"></p>
                                    <p v-if="( ! vendor_id && ! is_frontend )" class="no_of_vendor">
                                        {{ __( 'No. of Vendors:', 'dokan' ) }}
                                        <span class="vendor-count">{{ level.vendor_count }}</span>
                                    </p>
                                    <p v-if="( vendor_id || is_frontend ) && isVendorAcquiredLevel( level )" class="level_acquisition">
                                        {{ __('Acquisition date: ', 'dokan') }}
                                        <strong>{{ badge.acquired[level.id].formatted_created_at }}</strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h3 v-else>{{ __( 'No levels found', 'dokan' ) }}</h3>
                </div>
                <bars width="64" height="64" color="#007bff" v-if="!badge.id" />
            </template>
        </Modal>
    </div>
</template>

<script>

import Modal from "./Modal.vue";
import Bars from "./Bars.vue";
import defaultBadgeData from '../BadgeSingle.json';
import mixin from "../Mixin.js";

export default {

    name: 'BadgeDetails',

    props: {
        is_frontend: {
            type: Boolean,
            default: false,
        },
    },

    mixins: [mixin],

    components: {
        Modal,
        Bars,
    },

    inject: ['getBadgeValue', 'getVerificationTypes'],

    data() {
        return {
            showBadgeDetailsModal: false,
            badge_id: this.getBadgeValue.id,
            vendor_id: undefined !== this.getBadgeValue.vendor_id ? this.getBadgeValue.vendor_id : 0,
            badge: this.getDefaultBadgeData(),
        };
    },

    created() {
    },

    mounted() {
        this.getBadgeData();
    },

    watch: {
        getBadgeValue: {
            handler(badgeData) {
                this.badge_id = badgeData.id;
                this.vendor_id = undefined !== badgeData.vendor_id ? badgeData.vendor_id : 0,
                this.getBadgeData();
            },
            deep: true,
        },
    },

    methods: {
        // filter by stores
        getBadgeData() {
            let self = this;
            let badge_id = self.badge_id;

            if ( undefined === badge_id || badge_id < 1 ) {
                self.badge = this.getDefaultBadgeData();
                return;
            }

            self.showBadgeDetailsModal = true;

            let args = {
                is_frontend: this.is_frontend,
            };

            if ( self.vendor_id ) {
                args.vendor_id = self.vendor_id;
            }

            dokan.api.get('/seller-badge/'+ badge_id, args ).done( ( response ) => {
                self.badge = response;
            } ).always( () => {

            } ).fail( ( jqXHR ) => {
                self.badge = this.getDefaultBadgeData();
                self.showBadgeDetailsModal = false;

                let message = dokan_handle_ajax_error( jqXHR );
                if ( message ) {
                    self.showErrorAlert( message );
                }
            } );
        },

        getDefaultBadgeData() {
            let badge_data = Object.assign( {}, defaultBadgeData );
            badge_data.event = {};
            badge_data.levels = [];
            badge_data.acquired = [];
            return badge_data;
        },

        isVendorAcquiredLevel( level ) {
            if ( undefined === this.badge.acquired ) {
                return false;
            }
            if ( this.badge.acquired[level.id] ) {
                return true;
            }
            return false;
        },

        hideModal() {
            this.showBadgeDetailsModal = false;
            this.badge = this.getDefaultBadgeData();
            this.loading = false;
        },
    }
}

</script>
<style lang="less" scoped>
.level_acquisition {
    display: flex;
    gap: 5px;
    color: #b3b3b3 !important;
    font-weight: 400 !important;

    strong {
        color: #78818f;
    }
}
</style>
